import {RepositoryWithLoading, RepositoryNotLoading} from "./Repository";

const resource = 'v2/schedules';

export default {
    list(params) {
        return RepositoryWithLoading.get(`${resource}`, {params});
    },
    single(schedule_id, params) {
        return RepositoryWithLoading.get(`${resource}/${schedule_id}`, {params});
    },
    loadMore(params) {
        return RepositoryNotLoading.get(`${resource}`, {params});
    }
}
